import { PrimitiveValueObject } from '@/domain/primitiveValueObject';

export class SquareApplicationId extends PrimitiveValueObject<string> {
  /**
   * 生成
   * @param value 値
   * @returns 値
   */
  static create(value: string): SquareApplicationId {
    return new SquareApplicationId(value);
  }
}
